import { FeatureT } from 'types/shared/core/Feature';

export const Feature = {
  plusPlanRequiredMessage: '이 기능은 Plus 요금제 이상에서만 제공합니다.',
  plusPlanRequiredShortMessage: 'Plus 이상 요금제에서 사용 가능합니다.',
  plusPlanOrEventRequiredMessage: 'Plus 이상 요금제 또는 이벤트 참여시 사용 가능합니다.',
  featureNames: new Map<FeatureT, string>([
    ['adFree', '광고 제거'],
    ['homework', '숙제 기능'],
    ['homeworkComment', '숙제 댓글'],
    ['homeworkCommentUpload', '숙제 댓글 파일 업로드'],
    ['attendanceRealtime', '실시간 출결'],
    ['postReview', '글 검토'],
    ['postRenotify', '다시 알림'],
    ['studentProfileEditControl', '학생 프로필 수정 제어'],
    ['billSumsVisibilityControl', '학원비 합계 노출 제어'],
    ['comsPostViewer', '글 뷰어'],
    ['comsPcChat', 'PC 상담톡'],
    ['chatSubscription', '채팅방 알림 구독'],
    ['simpleExam', '시험 점수 관리'],
    ['lessonReport', '수업 리포트'],
    ['exam', '시험 기능'],
    ['analysisReport', '성적 분석 리포트'],
    ['textbook', '교재 관리'],
  ]),
  featureIntroSlugs: new Map<FeatureT, string>([
    ['adFree', 'notice-advertisement'],
    ['homework', 'notice-homework'],
    ['homeworkComment', 'notice-homework'],
    ['homeworkCommentUpload', 'notice-homework'],
    ['attendanceRealtime', 'notice-schedule-management-system'],
    ['postReview', 'notice-post-review'],
    ['postRenotify', ''],
    ['studentProfileEditControl', ''],
    ['billSumsVisibilityControl', ''],
    ['comsPostViewer', ''],
    ['comsPcChat', 'pc-chat-app-early-supporter-rewards'],
    ['chatSubscription', ''],
    ['simpleExam', ''],
    ['lessonReport', ''],
    ['exam', ''],
    ['analysisReport', ''],
    ['textbook', ''],
  ]),
};
